import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyOfferDeductions from "./component";
import { fetchOffersDetailsCms, fetchKavachBanner } from "../post-inspection-diy/actions";
import { withRouter } from "react-router-dom";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        auctionResponse,
        priceBreakup,
        offersCmsData
    }
}) => ({
    inspectionResponse,
    auctionResponse,
    priceBreakup,
    offersCmsData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchOffersDetailsCmsConnect: fetchOffersDetailsCms,
    fetchKavachBannerConnect: fetchKavachBanner
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyOfferDeductions));
